import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";
import { useCreateEvent } from "./useCreateEvent";

export const NewEventButton = () => {
  const { showCreateEventModal } = useCreateEvent();

  return (
    <Button
      large
      type="button"
      variant="primary"
      onClick={showCreateEventModal}
      aria-haspopup
    >
      {t("events.new_event")}
    </Button>
  );
};
